// extracted by mini-css-extract-plugin
module.exports = {"paymentModal":"PaymentConfirmation_paymentModal__XgKBE","modalText":"PaymentConfirmation_modalText__1Xh2u"};